var bgColorVar = 'var(--iw3m2s4)';
var buttonNotificationSizeStyle = {
  sm: 'styles_sm__iw3m2s1',
  md: 'styles_md__iw3m2s2'
};
var notificationBaseStyle = 'styles__iw3m2s0';
var textColorVar = 'var(--iw3m2s3)';
var textStyles = 'styles__iw3m2s5';
export { bgColorVar, buttonNotificationSizeStyle, notificationBaseStyle, textColorVar, textStyles };
